import React from 'react';

export function TwoSliderHorizontalIcon({ size = 16, color = 'currentColor', style, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M13.9346 11.3327H15.3346V12.666H13.9346C13.6258 14.1875 12.2806 15.3327 10.668 15.3327C8.82702 15.3327 7.33464 13.8403 7.33464 11.9993C7.33464 10.1584 8.82702 8.66602 10.668 8.66602C12.2806 8.66602 13.6258 9.81119 13.9346 11.3327Z"
        fill="currentColor"
      />
      <path
        d="M6.73465 11.3327C6.69092 11.5481 6.66797 11.771 6.66797 11.9993C6.66797 12.2277 6.69092 12.4506 6.73465 12.666H0.667969V11.3327H6.73465Z"
        fill="currentColor"
      />
      <path
        d="M2.06798 4.66602C2.37683 6.18751 3.722 7.33268 5.33464 7.33268C7.17558 7.33268 8.66797 5.8403 8.66797 3.99935C8.66797 2.1584 7.17558 0.666016 5.33464 0.666016C3.722 0.666016 2.37683 1.81119 2.06798 3.33268H0.667969V4.66602H2.06798Z"
        fill="currentColor"
      />
      <path
        d="M9.33464 3.99935C9.33464 4.22766 9.31168 4.45061 9.26796 4.66602H15.3346V3.33268H9.26796C9.31168 3.54809 9.33464 3.77104 9.33464 3.99935Z"
        fill="currentColor"
      />
    </svg>
  );
}
